<template>
  <div class="el-tabs__inner">
    <draggable
      :list="fields"
      :clone="clone"
      class="row ma-0 pa-2 justify-center"
      :group="{ name: 'forms', pull: 'clone', put: false }"
      :sort="false"
      :move="onMove"
      @end="onEnd"
      @start="onStart"
    >
      <template v-for="(field, index) in fields">
        <span
          :key="index"
          v-if="field.type == 'Form'"
          class="badge button__sidebar v-btn v-btn--contained theme--light v-size--default font-weight-bold ma-2"
          >{{ $t(field.text) }}</span
        >
      </template>
    </draggable>
  </div>
</template>


<script>
import { FormBuilder } from "@/components/form_elements_expression/formbuilder.js";
// import draggable from "vuedraggable";
export default {
  name: "Elements",
  components: FormBuilder.$options.components,
  data() {
    return {
      store: ["elementMove", "isElement"],
      editable: true,
      isDragging: false,
      delayedDragging: false,
      fields: FormBuilder.$data.fields,
      dropElementOptions: FormBuilder.$data.dropElementOptions,
    };
  },

  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    clone(field) {
      console.log("---clone", field);
      return this._.cloneDeep(field);
    },
    cloneElement(index, field, form, fieldsDefaultID) {
      var cloned = this._.cloneDeep(field); // clone deep lodash
      cloned.id = `${fieldsDefaultID}`;
      form.splice(index + 1, 0, cloned);
      this.editElementProperties(cloned);
    },

    editElementProperties(field) {
      this.$store.activeFieldExpression = field;
      this.$store.activeTabForFieldsExpression = "properties";
    },
    onMove({ relatedContext, draggedContext }) {
      console.log("---onMove");
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    // Sets default page cursor as grabbing
    onStart() {
      document.documentElement.classList.add("draggable-cursor");
    },
    // Restores default page cursor
    onEnd() {
      document.documentElement.classList.remove("draggable-cursor");
    },
  },
};
</script>

<style lang="scss" scoped>
.button__sidebar {
  width: 100%;
  //   margin-bottom: 5px;

  .is-disabled & {
    opacity: 0.4;
  }
}

// Display this ghost in <main> only
.sortable__ghost {
  position: relative;
  max-width: 140px;
  //   border-bottom: 2px solid #3a8ee6;
  margin-top: -10px;
  //   margin-bottom: 2px;

  [type="button"] {
    display: none;
  }

  &:before {
    // content: "Drag it here";
    background-color: #ecf5ff;
    // color: #3a8ee6;
    position: absolute;
    // left: 50%;
    font-size: 10px;
    border-radius: 10px;
    // line-height: 15px;
    // padding: 0 10px;
    // top: -6px;
    transform: translateX(-50%);
  }
}
</style>
